module.exports = __webpack_public_path__ + "img/eu-1.9f6afa6a.jpg";